
import {Link} from 'react-router-dom'

const resume = ()=> {


    return(
        <div> 


        <div id="resume">

          <div>
            <h3>SKILLS</h3>
            <h4>Technical:</h4>
            <p>Frontend and Backend Technologies (HTML, CSS, Javascript, Python, MongoDB, PostgreSQL), Database Management, GitHub, Windows, Linux </p>
            <h4>Non-Technical:</h4>
            <p>Teamwork/Supervision, Time Management, Communication, Creativity, Empathy, Customer Focus</p>
          </div>


        <h3>EXPERIENCE</h3>


          <div className='petsmart'>
            <h4> PetSmart - Cross Trained Associate</h4>
            <p>2022-Present</p>
            <li>Answering customers' questions on dog behavior while using various positive reinforcement techniques as corrective methods </li>
            <li>Prioritizing animal safety through training, grooming, and in store interactions </li>
            <li>Establishing excellent customer care and communication with clients</li>

          </div>

          <div className='chipotle'>
            <h4>Chipotle - Kitchen Manager</h4>
            <p>2021-2022</p>
            <li>Trained and supervised food safety guidlines, customer service etiquette, and food inventory</li>
            <li>Managed food inventory using FIFO and other methods to ensure freshness and no food waste</li>
            <li>Conducted daily quality food checks throughout shift</li>
          </div>

          <div className='nike'>
            <h4>Nike - Warehouse Associate</h4>
            <p>2020-2021</p>
            <li>Attended daily stand-up meetings to discuss progress, new policies, etc</li>
            <li>Reviewed, packaged and labeled customer orders </li>
          </div>


        </div>

        <div id="resume">
            <h3>EDUCATION</h3>

            <div>
            <h4>General Assembly - Software Engineer Immersive Certification</h4>
            <p>2022-2022</p>
            <li>Over 420 hours of immersive programming utilizing full-stack technologies</li>
            <li>Deployed various projects both individually and with a team</li>
            <li>Utilized design, code, and test applications to ensure usability and maintain a coherent workspace</li>
            </div>

            <div>
              <h4> Animal Behavior College - CPDT Certification</h4>
              <p>2018-2020</p>
              <li>Tailored training sessions to meet the needs of individuals and their pets</li>
              <li>Mentored with a professional to understand pet behavior and empathize with clients
</li>
            </div>


            
        </div>

        <div >
                <Link to='/'><button id="side_bar1">Home</button></Link>
                <Link to='/resume'><button id="side_bar2">Resume</button></Link>
                <Link to='/portfolio'><button id="side_bar3">Portfolio</button></Link>
               
            </div>
 
       
        </div>
    )
}

export default resume